// The demo window as the front-ends read it (spec/24 §3, §4.3): what `GET/POST /v1/me/demo` answered, against the
// server's clock rather than the device's.
//
// The server says when the window ends and what time it was when it answered (`serverTime`). A device whose clock is
// minutes out would end the demo early or late if it compared `endsAt` with its own `Date.now()`, so the offset
// between the two is taken once, when the answer arrives, and every later "now" is the device's clock plus it.
// Nothing here reads a clock: the caller passes `Date.now()` in.
/** The offset between the server's clock and the device's, from one answer and the device's time it arrived. */
export function demoClockFrom(access, receivedAt) {
    const server = Date.parse(access.serverTime);
    return { offsetMs: Number.isNaN(server) ? 0 : server - receivedAt };
}
/** Where the window stands at the device's `deviceNow`, on the server's clock. */
export function demoWindowStatus(window, clock, deviceNow) {
    if (window === null)
        return { kind: 'none' };
    const now = deviceNow + clock.offsetMs;
    const endsAt = Date.parse(window.endsAt);
    const nextStartAt = Date.parse(window.nextStartAt);
    if (now < endsAt)
        return { kind: 'active', secondsLeft: Math.max(0, Math.ceil((endsAt - now) / 1000)), endsAt };
    return { kind: 'ended', nextStartAt, canStartAgain: now >= nextStartAt };
}
/**
 * `sessionStorage`: the demo page a visitor was on the way to when they had to sign in first — `/kiosk/` or `/both`
 * (spec/24 §4.1). The console's sign-in brings them into the console; the demo console's frame sends them on.
 */
export const DEMO_NEXT_PAGE_KEY = 'clavian.demo.next';
/** `sessionStorage`: which PC this tab's demo kiosk is (spec/24 §4.4). */
export const DEMO_KIOSK_STATION_KEY = 'clavian.demo.kiosk.station';
/** `12:34`, or `1:02:03` past the hour — the banner's countdown. */
export function formatDemoCountdown(totalSeconds) {
    const seconds = Math.max(0, Math.floor(totalSeconds));
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const rest = seconds % 60;
    const two = (value) => String(value).padStart(2, '0');
    return hours > 0 ? `${hours}:${two(minutes)}:${two(rest)}` : `${minutes}:${two(rest)}`;
}
//# sourceMappingURL=window.js.map